/* @flow */
import { ActionTypes } from '../constants/WidgetConstants';
import Widgets from 'collections/Widgets';
import Store from 'lib/Store';

class WidgetStore extends Store {
  getInitialState() {
    return {
      widgets: new Widgets(),
    };
  }

  getAll() {
    return this.state.widgets;
  }

  addNewWidget(widget) {
    this.state.widgets.add(widget);
  }

  handleDispatch(action: Object): void {
    switch (action.type) {
      case ActionTypes.WIDGETS_LOADED:
        action.widgets.map((widget) => this.addNewWidget(widget));
        this.emitChange();
        break;
      default:
        break;
    }
  }
}

export default new WidgetStore();



// WEBPACK FOOTER //
// ./src/settings/stores/WidgetStore.js